module.exports = __webpack_public_path__ + "img/map_Z5.4.A.02.f73dd903.svg";